import {NavigationClickerModalType} from './NavigationClickerModalStore.constants';
import {NavigationClickerModalState} from './NavigationClickerModalStore.types';

import {injected} from 'brandi';

import {Store} from '@/stores/Store';

export class NavigationClickerModalStore extends Store<NavigationClickerModalState> {
  constructor() {
    super({
      currentModalType: null,
      prevModalType: null,
    });
  }

  public isCurrentModalTypeNull = (): boolean => {
    return this.getState().currentModalType === null;
  };

  public isCurrentModalTypeGifts = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.Gifts;
  };

  public isCurrentModalTypeGiftsGameFinished = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.GiftsGameFinished;
  };

  public isCurrentModalTypeGiftsGameMocks = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.GiftsGameMocks;
  };

  public isCurrentModalTypeImprovements = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.Improvements;
  };

  public isCurrentModalTypeLeaderboard = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.Leaderboard;
  };

  public isCurrentModalTypeLeaderboardGameFinished = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.LeaderboardGameFinished;
  };

  public isCurrentModalTypeTasks = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.Tasks;
  };

  public isCurrentModalTypeDaily = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.Daily;
  };

  public isCurrentModalTypeFaq = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.FAQ;
  };

  public isCurrentModalTypeGameStatistics = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.GameStatistics;
  };

  public isCurrentModalTypeGameStatisticsMocks = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.GameStatisticsMocks;
  };

  public isCurrentModalTypeBeforeResultsInfo = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.BeforeResultsInfo;
  };

  public isCurrentModalTypeWinners = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.Winners;
  };

  public isCurrentModalTypeSettings = (): boolean => {
    return this.getState().currentModalType === NavigationClickerModalType.Settings;
  };

  public getCurrentModalType = (): NavigationClickerModalType | null => {
    return this.getState().currentModalType;
  };

  public getPrevModalType = (): NavigationClickerModalType | null => {
    return this.getState().prevModalType;
  };

  public setCurrentModalType = (currentModalType: NavigationClickerModalType | null): void => {
    this.setValue('currentModalType', currentModalType);
  };

  public setPrevModalType = (prevModalType: NavigationClickerModalType | null): void => {
    this.setValue('prevModalType', prevModalType);
  };
}

injected(NavigationClickerModalStore);
